// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Signup_container__vDPa- {
  display: flex;
  flex-direction: row;
}

.Signup_form-container__vIBsC {
  width: 75%;
  margin-right: 5%;
}

.Signup_popup__gghQX {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.Signup_popup__gghQX .Signup_popup-text__GRnTd {
  margin-top: 56px;
  margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/views/Signup/Signup.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,UAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;AAAE;EACE,gBAAA;EACA,mBAAA;AAEJ","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n}\n\n.form-container {\n  width: 75%;\n  margin-right: 5%;\n}\n\n.popup {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  .popup-text {\n    margin-top: 56px;\n    margin-bottom: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Signup_container__vDPa-`,
	"form-container": `Signup_form-container__vIBsC`,
	"popup": `Signup_popup__gghQX`,
	"popup-text": `Signup_popup-text__GRnTd`
};
export default ___CSS_LOADER_EXPORT___;
